<section class="index-banner-inner pad" style="background-image: url(assets/images/inner_banner.jpg);">
	<div class="container-fluid">
		<div class="container">
			<h2 class="title-banner mbtm20"> ILMS Features</h2>
		</div>
	</div>
</section>

<section class="about-cont">
	<div class="container pbtm2em">
		<div class="row">
			<div class="col-md-12">
				<h2 class="title2 ptop2em">
					<strong>Interlace Laboratory Management System</strong>
				</h2>
			</div>
			<div class="col-sm-12">
				<p>Interlace Laboratory Management System (ILMS) is a highly efficient Laboratory Management Software that can increase the operational efficiency of your organization by simplifying the laboratory operations while ensuring compliance to quality standards. ILMS includes diagnostics, inventory control, billing and payments, quality control, along with support for uni-directional and bi-directional device integrations. </p>
				<div class="col-sm-12 text-center">
					<img src="assets/images/features.png" alt="Interlace Laboratory Management System">
					<br clear="all">
					<p></p>
				</div>
			<div class="row">
				
			<div class="col-sm-6 my-5">
				<h2 class="title2">
					<strong>Salient Features of ILMS STANDARD Version:</strong>
				</h2>
				<ul class="ILMS_list Features-list">
					<li>Real-time progress tracking.</li>
					<li>Easy Patient Registration (Individual/Bulk).</li>
					<li>Single Click Barcode generation.</li>
					<li>Single Click Bill / Invoice generation.</li>
					<li>Barcode-based Identification.</li>
					<li>WhatsApp, SMS & Email based Reports & Notifications.</li>
					<li>Elimination of  manual entry errors.</li>
					<li>Ability to Configure different pricing for different test packages.</li>
					<li>Quick and easy reporting.</li>
					<li>Faster processing time.</li>
					<li>Bulk Entry of Report Values Using Excel.</li>
					<li>Stock management & inventory.</li>
					<li>Report configuration.</li>
					<li>Management information system report (MIS).</li>
					<li>Auto calculation of test parameters.</li>
				</ul>
			</div>
			<div class="col-sm-6 my-5">
				<h2 class="title2">
					<strong>Salient Features of ILMS LITE Version:</strong>
				</h2>
				<ul class="ILMS_list Features-list">
					<li>Real-time progress tracking.</li>
					<li>Easy Patient Registration (Individual).</li>
					<li>Single Click Barcode generation.</li>
					<li>Single Click Bill / Invoice generation.</li>
					<li>Barcode-based Identification.</li>
					<li>WhatsApp, SMS & Email based Reports & Notifications.</li>
					<li>Elimination of manual entry errors.</li>
					<li>Ability to configure different pricing for different test packages.</li>
					<li>Quick and easy reporting.</li>
					<li>Faster processing time.</li>
					<li>Report configuration.</li>
					<li>Management information system report (MIS).</li>
					<li>Auto calculation of test parameters.</li>
				</ul>
			</div>

		</div>
		<div class="row">
				<div class="col-sm-6 my-5">
				<h2 class="title2">
					<strong>Automated Test Results Transfer/ Device Integration:</strong>
				</h2>
				<ul class="ILMS_list Features-list">
					<li>Error free test results through device integration. </li>
					<li>Import test result from devices through text or CSV file. </li>
					<li>Support for uni-directional and bi- directional device integration. </li>
					<li>Consolidate test results from various devices.</li>
				</ul>
				</div>
				<div class="col-sm-6 my-5">
				<h2 class="title2">
						<strong>Our ILMS Software Supports:</strong>
				</h2>
				<ul class="ILMS_list Features-list">
					<li>API Integration.</li>
					<li>RS 232 Data Import.</li>
					<li>USB Data Import.</li>
					<li>Any other data Transfer Port from Medical Devices.</li> 
				</ul>
				</div>
			</div>
				
				<div class="col-sm-12">
				<h2 class="title2">
					<strong>ILMS Process Flow:</strong>
				</h2>
				<div class="col-sm-12 text-center">
					<img src="assets/images/product_image2.png" alt="Interlace Laboratory Management System">
					<br clear="all">
					<p></p>
				</div>
				</div>
				<!-- <div class="row"> -->
				<!-- <div class="col-sm-6 my-5"> -->
					<!-- <h2 class="title2"> -->
						<!-- <strong>Our ILMS Software supports:</strong> -->
					<!-- </h2> -->
					<!-- <ul class="ILMS_list Features-list"> -->
						<!-- <li>API Integration.</li> -->
						<!-- <li>RS 232 Data Import.</li> -->
						<!-- <li>USB Data Import.</li> -->
						<!-- <li>Any other data Transfer Port from Medical Devices.</li>  -->
					<!-- </ul> -->
				<!-- </div> -->
				<!-- <div class="col-sm-6 my-5"> -->
					<!-- <h2 class="title2"> -->
					<!-- <strong _ngcontent-lwv-c49="">ILMS Deployment Options:</strong></h2> -->
					<!-- <img src="/assets/images/deployment_option.png" alt="" style="height: auto;"> -->
				<!-- </div> -->
				<!-- </div> -->
			</div>
		</div>
	</div>
</section>
